import styled from 'styled-components';
import { NavLink, useHistory } from 'react-router-dom';
import { ConfirmModal } from '../../modal/confirm.modal';
import { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { authState } from '../../../atoms/authState';

const menuList = [
  {
    title: '회원 리스트',
    url: '/admin/member/list',
  },
  {
    title: '1:1 문의',
    url: '/admin/inquiry/list',
  },
  {
    title: '공지사항',
    url: '/admin/notice/list',
  },
  {
    title: '회사 리스트',
    url: '/admin/corporation/list',
  },
];

const AdminHeader = () => {
  const [confirmModal, setConfirmModal] = useState(false);
  const setAuth = useSetRecoilState(authState); // Recoil 상태 업데이트 함수
  const history = useHistory(); // useHistory 훅을 사용하여 페이지 이동 처리

  const handleConfirmClose = () => {
    setConfirmModal(false);
  };

  const handleLogoutClicked = () => {
    setConfirmModal(true);
  };

  const handleConfirmClicked = () => {
    // 로그아웃 로직
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expire');
    localStorage.removeItem('authState');

    // Recoil 상태 초기화
    setAuth({
      isAuthenticated: false,
      userType: '',
    });

    // 홈 화면으로 리다이렉트
    history.push('/admin/login');
  };

  return (
    <Container>
      <div className="inner">
        <div className="left">
          <div className="logo">데일리 콘(Daily Con)</div>
          <div className="menu-list">
            <ul>
              {menuList.map((item, i) => (
                <li key={i}>
                  <NavLink to={item.url}>{item.title}</NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="right">
          <div className="logout" onClick={handleLogoutClicked}>
            로그아웃
          </div>
        </div>
      </div>

      {confirmModal ? (
        <ConfirmModal
          handleConfirmClose={handleConfirmClose}
          confirmText="로그아웃 하시겠습니까??"
          onClick={handleConfirmClicked}
        />
      ) : null}
    </Container>
  );
};

export default AdminHeader;

// style
const Container = styled.header`
  height: 8.2rem;
  width: 100%;
  .inner {
    max-width: 160rem;
    width: 100%;
    padding: 1.8rem 2.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .logo {
        width: 14.2rem;
        height: 4.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.8rem;
        font-weight: 800;
        color: #b5b5b5;
      }
      .menu-list {
        margin-left: 6.4rem;
        ul {
          display: flex;
          gap: 4.2rem;
          li {
            a {
              font-size: 1.6rem;
              font-weight: 700;
              color: rgba(78, 85, 101, 0.59);
              &.active {
                color: rgba(78, 85, 101, 1);
              }
            }
          }
        }
      }
    }
    .right {
      .logout {
        color: #b4b4b4;
        font-size: 1.3rem;
        font-weight: 400;
        :hover {
          color: #333;
        }
      }
    }
  }
`;
